<template>
    <div class="modal fade" id="featureUnavailableOfflineModal" ref="featureUnavailableOfflineModal" tabindex="-1" role="dialog" aria-labelledby="featureUnavailableOfflineModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" style="background-color: #FFF3F3;">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-bottom: 48px;">
                    <div class="row">
                        <div class="col-12 text-center">
                            <span class="note-text">{{ $t('offline.modals.feature_unavailable') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FeatureUnavailableOfflineModal",
        props: [],
        data() {
            return {
            }
        },
        created() {
                      
        },
        mounted() {
            
        },
        methods: {
            
        },
    };
</script>
<style scoped>

</style>
